export const enum ECostType {
    CPM = 'cpm',
    CPO = 'cpo',
    CPC = 'cpc'
}

export type TCostType = ECostType.CPM | ECostType.CPO | ECostType.CPC;

export interface ICostTypePreset {
    readonly minBet?: number,
    readonly maxBet?: number,
    readonly defaultValue?: number,
    readonly step?: number
}

export type TCostTypePresets = Record<TCostType, ICostTypePreset>;

export enum EMinCostTypeField {
    CPM = 'minCPM',
    CPO = 'minCPO',
    CPC = 'minCPC'
}
